import Repository from "../Repository";

const Create = "createAuthor";
const GetAll = "getAllAuthor"
const GetAllList = "getAllAuthorList"
const EditAuthor='edit'


export default {
  CreateAuthor(payload) {
    return Repository.post(transformRoute(Create),payload);
  },
  getAllAuthor(payload) {
    return Repository.post(transformRoute(GetAll),payload);
  },
  getAllAuthorList(payload) {
    return Repository.post(transformRoute(GetAllList),payload);
  },
  EditAuthor(payload){
    return Repository.post(transformRoute(EditAuthor),payload)
  }
};

const transformRoute = (route) => {
  return `eLearning/elearnauthor/${route}`;
};
